import React/* , { Component, Fragment, useState } */ from 'react';
import { connect } from 'react-redux';
import { Redirect } from "react-router-dom"
import Theme from "./../../assets/Theme";
//import config from "./../../store/config/config.json";
import Header from './../../components/Header';
import Footer from './../../components/Footer';
import { getBookingAction } from "../../store/actions/";
import PurchaseDetail from './../CheckoutPage/partials/PurchaseDetail'
import ProductDetail from './../CheckoutPage/partials/ProductDetail'
import ProductDetailPasses from './../CheckoutPage/partials/ProductDetailPasses'
//import Datepicker from "./../../components/Datepicker"
import DatepickerValPass from "./../../components/DatepickerValPass"
import String from './../../components/String'
import FormInputNumber from './../../components/FormInputNumber'
import StringNumber from './../../components/StringNumber'
import StringNumberPass from '../../components/StringNumberPass'
import NumberCuit from '../../components/NumberCuit'
import Email from './../../components/Email'
import FormInputSelect from './../../components/FormInputSelect'
import DatePickerRange from '../../components/DatePickerRange'
import DatePickerDateAge from '../../components/DatePickerDateAge'
import SimpleSelectDocType from './../../components/SimpleSelectDocType'
//import PaymentMethods from './../CheckoutPage/PaymentMethods/PaymentMethods'
import moment from 'moment';
import 'moment/locale/es';
import 'moment-timezone';
import { Container, Grid, Paper, Icon, Typography, Button, FormControl, Select, MenuItem, Tooltip } from '@material-ui/core';
import { getDocType, getCountry, getGenre } from './../../store/services/InfoFormService';

import { FormGroup, FormControlLabel, Link } from '@material-ui/core';
import CheckboxForm from '@material-ui/core/Checkbox';

import CircularProgress from '@material-ui/core/CircularProgress';

import Timer from './../CheckoutPage/partials/Timer';
import PopoverSimpleTitleContent from '../CheckoutPage/partials/PopoverSimpleTitleContent';


class CheckoutPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedNationality: '',
            checkTermsConditions: false,
            pas: [],
            contact: { name: '', lastname: '', phone: '', email: '', genre: '' },
            cuilcuitType: 'CUIL',
            cuilcuitNumber: [],
            firstName: [],
            lastName: [],
            birthday: [],
            docType: [],
            docNumber: [],
            country: [],
            nationality: [],
            genre: [],
            phoneNumber: [],
            expirationDate: [],
            emailAdress: [],
            errors: {
                status: {},
                text: {
                    cuilcuitNumber: '',
                    pas: [],
                    namecontact: '',
                    lastnamecontact: '',
                    phonecontact: '',
                    emailcontact: '',
                    genrecontact: '',
                    firstName: '',
                    lastName: '',
                    birthday: '',
                    docType: '',
                    docNumber: '',
                    country: '',
                    nationality: '',
                    genre: '',
                    phoneNumber: '',
                    expirationDate: '',
                    emailAdress: '',
                },
            }
        };
        this.tokenClient = this.props.match.params.token
        this.config = require(`./../../store/config/${this.tokenClient}/config.json`);
    }

    handlenationality = (value, index) => {
        if (index === 0) {
            this.setState({
                selectedNationality: value
            })
        }
    }

    callbackPas = (boolean, value, i) => {
        let pas = this.state.pas;
        pas[i] = boolean;
        let docType = this.state.docType;
        docType[i] = value;
        let docNumber = this.state.docNumber;
        docNumber[i] = '';
        let expirationDate = this.state.expirationDate;
        this.setState({ pas: pas, docType: docType, docNumber: docNumber });

        if (!boolean) {
            expirationDate[i] = '';
            this.setState({ expirationDate: expirationDate });
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    checkoutTermsConditions = () => {
        this.setState(prevState => ({
            checkTermsConditions: !prevState.checkTermsConditions
        }));
    }

    formatDate = (date = new Date()) => {
        const currentYear = date.getFullYear();
        const nextYear = currentYear + 1;
        // Verifica si el próximo año es bisiesto
        const isNextYearLeap = (nextYear % 4 === 0 && nextYear % 100 !== 0) || (nextYear % 400 === 0);
        const month = date.toLocaleString('default', { month: '2-digit' });
    
        let day = date.toLocaleString('default', { day: '2-digit' });
        if (month === '02' && day === '29' && !isNextYearLeap) {
            day = '28'; // Ajustar el día a 28 si el próximo año no es bisiesto
        }
    
        return [nextYear.toString(), month, day].join('-');
    }
      
      

    handleSubmit(e) {
        let passenger = {}
        let passengers = []
        let firstNames = []
        let firstName = {}
        let lastNames = []
        let lastName = {}
        let datesOfBirth = []
        let birthday = {}
        let docNumbers = []
        let docNumber = {}
        let expirationDates = []
        let expirationDate = {}

        let cuilcuitType = ''
        let cuilcuitNumber = ''

        let apiToken = this.props.location.state.reserve.request.info ? this.props.location.state.reserve.request.info.apiToken : this.config.credential.api.token;

        e.preventDefault();

        let contact = new Object();
        let countValid = 0;
        let count = 0;

        if (this.state.contact['name'] && this.state.contact['name'] !== null) {
            count++;
            if (this.state.contact['name'].state.defaultValue !== '') {
                countValid++;
                contact['firstName'] = this.state.contact['name'].state.defaultValue;
            }
        }
        contact['title'] = (this.state.genre[0].state.defaultValue === "F") ? "MS" : "MR"
        contact['phoneNumber'] = '+54 11 52728400'
        contact['emailAddress'] = 'trenes@tije.travel'
        if (this.state.contact['lastname'] && this.state.contact['lastname'] !== null) {
            count++;
            if (this.state.contact['lastname'].state.defaultValue !== '') {
                countValid++;
                contact['lastName'] = this.state.contact['lastname'].state.defaultValue;
            }
        }
        if (this.state.contact['email'] && this.state.contact['email'] !== null) {
            count++;
            if (this.state.contact['email'].state.defaultValue !== '') {
                countValid++;
                contact['emailClient'] = this.state.contact['email'].state.defaultValue;
            }
        }
        if (this.state.contact['phone'] && this.state.contact['phone'] !== null) {
            count++;
            if (this.state.contact['phone'].state.defaultValue !== '') {
                countValid++;
                contact['phoneClient'] = '+' + this.state.contact['phone'].state.defaultValue;
            }
        }

        let index = ""

        this.props.location.state.reserve.bookingItems[0].travelers.map((value, i) => {
            passenger = {}
            firstName = {}
            lastName = {}
            birthday = {}
            docNumber = {}
            expirationDate = {}

            index = i + 1

            const isRenfeSome = this.props.location.state.reserve.bookingItems.some(bookingItem =>
                bookingItem.products.some(product => product.supplier === 'RENFE')
            );

            const isRenfe = this.props.location.state.reserve.bookingItems[0].products[0].supplier === 'RENFE'

            const isPases = this.props.location.state.reserve.bookingItems[0].type === "pass-offer"

            if (this.state.firstName[i] && this.state.firstName[i] !== null) {
                count++;
                if (this.state.firstName[i].state.defaultValue !== undefined) {
                    countValid++;
                    passenger['firstName'] = this.state.firstName[i].state.defaultValue;
                }
            }
            if (this.state.lastName[i] && this.state.lastName[i] !== null) {
                count++;
                if (this.state.lastName[i].state.defaultValue !== '') {
                    countValid++;
                    passenger['lastName'] = this.state.lastName[i].state.defaultValue;
                }
            }
            if (this.state.birthday[i] && this.state.birthday[i] !== null) {
                count++;
                if (this.state.birthday[i].state.selectedDate !== null) {
                    countValid++;
                    passenger['dateOfBirth'] = this.state.birthday[i].state.selectedDate.replace("/", "-").replace("/", "-")//this.state.birthday[i].state.selectedDate.split("/").join("-")//'1990-05-29'
                }
            }

            //docType
            if (isPases) {
                /* if (isRenfeSome) {
                    count++;
                    countValid++;
                    passenger['docType'] = 'PP';
                } else if (this.state.docType[i] && this.state.docType[i] !== null) {
                    count++;
                    if (this.state.docType[i].state.defaultValue !== '') {
                        countValid++;
                        passenger['docType'] = this.state.docType[i].state.defaultValue
                    }
                } */
                count++;
                countValid++;
                passenger['docType'] = 'PP';
                
            }else {
                count++;
                countValid++;
                passenger['docType'] = 'PP';
            }

            //docNumber
            if (isPases) {
                /* if (this.state.docNumber[i] && this.state.docNumber[i] !== null) {
                    count++;
                    if (this.state.docNumber[i].state.defaultValue !== '') {
                        countValid++;
                        passenger['docNumber'] = this.state.docNumber[i].state.defaultValue
                    }
                } */
                count++;
                countValid++;
                passenger['docNumber'] = 0;
                
            }else {
                if (isRenfeSome) {
                    if (this.state.docNumber[i] && this.state.docNumber[i] !== null) {
                        count++;
                        if (this.state.docNumber[i].state.defaultValue !== '') {
                            countValid++;
                            passenger['docNumber'] = this.state.docNumber[i].state.defaultValue
                        }
                    }
                } else {
                    count++;
                    countValid++;
                    passenger['docNumber'] = 0;
                }
            }

            //Expiration
            if (isPases) {
                /* if (this.state.expirationDate[i] && this.state.expirationDate[i] !== null) {
                    count++;
                    if (this.state.expirationDate[i].state.selectedDate !== null) {
                        countValid++;
                        passenger['expirationDate'] = this.state.expirationDate[i].state.selectedDate.replace("/", "-").replace("/", "-")
                    }
                } */
                count++;
                countValid++;
                passenger['expirationDate'] = this.formatDate(new Date());
                
            }else {
                if (isRenfeSome) {
                    if (this.state.expirationDate[i] && this.state.expirationDate[i] !== null) {
                        count++;
                        if (this.state.expirationDate[i].state.selectedDate !== null) {
                            countValid++;
                            passenger['expirationDate'] = this.state.expirationDate[i].state.selectedDate.replace("/", "-").replace("/", "-")
                        }
                    }
                } else {
                    count++;
                    countValid++;
                    passenger['expirationDate'] = this.formatDate(new Date());
                }
            }

            //passenger['country'] = this.state.country[i].state.defaultValue
            //passenger['nationality'] = this.state.nationality[i].state.defaultValue
            //passenger["emailAddress"] = this.state.emailAdress[i].state.defaultValue
            passenger['id'] = "traveler-" + index
            passenger['age'] = value.age
            passenger['type'] = value.type
            passenger['leadTraveler'] = (i === 0) ? true : false
            passenger["countryOfResidence"] = this.state.country[i].state.defaultValue
            passenger["phoneNumber"] = '+' + this.state.contact['phone'].state.defaultValue
            passenger["emailAddress"] = this.state.contact['email'].state.defaultValue
            passenger['title'] = (this.state.genre[i].state.defaultValue === "F") ? "MS" : "MR"

            firstName = (this.state.firstName[i] && this.state.firstName[i].state.defaultValue !== undefined && this.state.firstName[i].state.defaultValue !== '') ? false : true
            lastName = (this.state.lastName[i] && this.state.lastName[i].state.defaultValue !== undefined && this.state.lastName[i].state.defaultValue !== '') ? false : true
            birthday = (this.state.birthday[i] && this.state.birthday[i].state.selectedDate !== null && this.state.birthday[i].state.selectedDate !== '' && this.state.birthday[i].state.selectedDate !== null) ? false : true
            //docNumber = (this.state.docNumber[i] && this.state.docNumber[i].state.defaultValue !== undefined && this.state.docNumber[i].state.defaultValue !== '') ? false : true        
            //expirationDate = (this.state.expirationDate[i] && this.state.expirationDate[i].state.selectedDate !== null && this.state.expirationDate[i].state.selectedDate !== '' && this.state.expirationDate[i].state.selectedDate !== null) ? false : true

            /* docNumber = (
                isPases ? ((this.state.docNumber[i] && this.state.docNumber[i].state.defaultValue !== undefined && this.state.docNumber[i].state.defaultValue !== '') ? false : true                ) 
                : ( isRenfeSome ? ( (this.state.docNumber[i] && this.state.docNumber[i].state.defaultValue !== undefined && this.state.docNumber[i].state.defaultValue !== '') ? false : true ) 
                    : ( false ) )
            ) */

            /* expirationDate = (
                isPases ? ( (this.state.expirationDate[i] && this.state.expirationDate[i].state.selectedDate !== null && this.state.expirationDate[i].state.selectedDate !== '' && this.state.expirationDate[i].state.selectedDate !== null) ? false : true ) 
                : ( isRenfeSome ? ( (this.state.expirationDate[i] && this.state.expirationDate[i].state.selectedDate !== null && this.state.expirationDate[i].state.selectedDate !== '' && this.state.expirationDate[i].state.selectedDate !== null) ? false : true ) 
                    : ( false  ) )
            ) */

            //no se valida docNumber ni expirationDate para tickets ni pases, se manda default 0 y expirationDate a un año
            docNumber = false
            expirationDate = false
            
            expirationDates.push(expirationDate)
            docNumbers.push(docNumber)
            datesOfBirth.push(birthday)
            firstNames.push(firstName)
            lastNames.push(lastName)
            passengers.push(passenger)
        })

        // Cuil/Cuit type and number
        if (this.state.nationality[0].state.defaultValue === "AR") {
            count++;
            if (this.state.cuilcuitNumber.state.error == false) {
                countValid++;
                cuilcuitType = this.state.cuilcuitType;
                cuilcuitNumber = this.state.cuilcuitNumber.state.defaultValue;
            }
        } else {
            cuilcuitType = '';
            cuilcuitNumber = '';
        }

        this.setState({
            errors: {
                //valida campos contacto
                'namecontact': (this.state.contact.name && this.state.contact.name.defaultValue !== '' && this.state.contact.name.state.errorText === '') ? false : true,
                'lastnamecontact': (this.state.contact.lastname && this.state.contact.lastname.defaultValue !== '' && this.state.contact.lastname.state.errorText === '') ? false : true,
                'phonecontact': (this.state.contact['phone'] && this.state.contact['phone'].state.defaultValue !== undefined && this.state.contact['phone'].state.defaultValue !== '') ? false : true,
                'emailcontact': (this.state.contact.email && this.state.contact.email.defaultValue !== '' && this.state.contact.email.state.errorText === '') ? false : true,
                'cuilcuitNumber': (this.state.cuilcuitNumber && this.state.cuilcuitNumber.defaultValue !== '' && this.state.cuilcuitNumber.state?.error === false) ? false : true,
                //valida datos pasajeros
                "firstName": firstNames,
                'lastName': lastNames,
                'birthday': datesOfBirth,
                'docNumber': docNumbers,
                'expirationDate': expirationDates
            }
        });

        const billingInformation = {
            meansOfPayment: "ALLOWANCE",
            buyerDetails: {
                agency: {
                    agencyName: "Agency name",
                    emailAddress: "era.user@world.com",
                    phoneNumber: "987654321"
                }
            },
            address: {
                address1: "Quality St",
                address2: "",
                state: "Alaska",
                zipCode: "12345",
                city: "Nowhere",
                country: "AQ"
            }
        }

        const cuilcuitData = {
            cuilcuitType: cuilcuitType,
            cuilcuitNumber: cuilcuitNumber,
        }

        const submitDate = {
            hash: this.props.location.state.reserve.hash,
            travelersDetails: passengers,
            billingInformation: billingInformation,
            bookingContact: contact,
            agencyBookingNumber: 'ClientBookingNumber2',
            cuilcuitData: cuilcuitData
        }

        /* console.log('docNumber count', count)
        console.log('docNumber countValid', countValid)
        console.log('docNumber submitDate', submitDate) */

        if ((count === countValid) && this.state.checkTermsConditions) {
            this.props.dispatchGetBooking(submitDate, this.props.match.params.token, apiToken);
            this.setState({ success: false, loading: true })
        }
    }

    arrDatePass = (bookingItems) => {
        const arr = [];
        bookingItems.map((item, i) => {
            let itemLegArrival = (item.leg ? item.leg.arrival : item.expirationDate);
            let date = moment(itemLegArrival).locale('es').format('YYYY/MM/DD');
            arr.push(date);
        })
        var max = arr.reduce(function (valor1, valor2) { return new Date(valor1) > new Date(valor2) ? valor1 : valor2; });
        return max;
    }

    GetPassengersFormTickets = (props) => {
        //const renfe = props.bookingItems[0].products[0].supplier === 'RENFE' ? true : false;

        const isRenfeSome = props.bookingItems.some(bookingItem =>
            bookingItem.products.some(product => product.supplier === 'RENFE')
        );
        
        let bookingItemsLenght = props.bookingItems.length - 1;
		const messageTickets = `Infoas: Viajan gratis sin derecho a asiento y sin ticket según edades: Trenes Reino Unido 0-4 años, Alemania y Suiza de 0-5 años, resto de Trenes 0-3 años inclusive.`
		const messagePasses = `Infoas: Viajan gratis sin derecho a asiento y sin ticket  según edades: Pase Eurail 0-3 años y Pase Suizo de 0-5 años inclusive. `
		const page = sessionStorage.getItem('typeProduct');
        
        return (
            <Paper className="paper form-passengers">
                <Typography variant="h2" className="subtitle">Datos de los pasajeros</Typography>

                {props.bookingItems[0].travelers.map((item, index) =>
                    <div key={index} className="pax">
                        <Typography variant="h4" className="subtitle_pax">Pasajero {index + 1}
                            {item.type === 'ADULT' ? ' (ADULTO' : item.type === 'SENIOR' ? ' (SENIOR' : item.type === 'YOUTH' ? ' (MENOR/JOVEN' : item.type})
                            {item.age < 30 ? item.type === 'YOUTH' && item.age == 1 ? ' (' + item.age + ' año)' : ' (' + item.age + ' años)' : ''}
                            {(item.age <= 5 && page === "tickets")
								&& <span>
								<PopoverSimpleTitleContent
								  name="info_timer"
								  title=''
								  content={messageTickets}
								  icon="info_outline"
								/>
							  </span>}
                            {(item.age <= 5 && page === "passes")
                            && <span>
                            <PopoverSimpleTitleContent
                                name="info_timer"
                                title=''
                                content={messagePasses}
                                icon="info_outline"
                            />
                            </span>}</Typography>

                        <Grid container spacing={1}>
                            <Grid item md={5}>
                                <String
                                    id={`${'firstName-'}${index}`}
                                    name={`${'firstName-'}${index}`}
                                    label="Nombre"
                                    defaultValue={this.state.firstName[index]?.state.defaultValue}
                                    placeholder="Primer Nombre"
                                    ref={element => { this.state.firstName[index] = element }}
                                    disabled={this.state.disabled ? this.state.disabled : false}
                                    error={this.state.errors.firstName !== undefined ? this.state.errors.firstName[index] : this.state.errors.text.firstName}
                                    initial={(this.state.firstName[index] !== null) ? false : true}
                                />
                            </Grid>
                            <Grid item md={5}>
                                <String
                                    id={`${'lastName-'}${index}`}
                                    name={`${'lastName-'}${index}`}
                                    label="Apellido"
                                    defaultValue={this.state.lastName[index]?.state.defaultValue}
                                    ref={element => { this.state.lastName[index] = element }}
                                    placeholder="Primer Apellido"
                                    error={this.state.errors.lastName !== undefined ? this.state.errors.lastName[index] : this.state.errors.text.lastName}
                                    disabled={this.state.disabled ? this.state.disabled : false}
                                    initial={(this.state.lastName[index] !== null) ? false : true}
                                />
                            </Grid>

                            <Grid item md={2}>
                                <FormInputSelect
                                    id={`genre-${index}`}
                                    name={`genre-${index}`}
                                    label="Sexo"
                                    defaultValue={this.state.genre[index] ? this.state.genre[index].state.defaultValue : "M"}
                                    optionsSelect={getGenre()}
                                    ref={element => { this.state.genre[index] = element }}
                                />
                            </Grid>

                            {isRenfeSome &&
                                <Grid item md={6}>
                                    <div className="group-inputs">
                                        <div className="label-group">{isRenfeSome ? 'Número de Pasaporte' : 'Tipo y número de documento'}</div>
                                        <Grid container spacing={1}>
                                            {isRenfeSome ? '' : <Grid item sm={5}>
                                                <SimpleSelectDocType
                                                    ref={element => { this.state.docType[index] = element }}
                                                    id={`${'docType-'}${index}${'docType'}`}
                                                    name={`${'docType-'}${index}${'docType'}`}
                                                    i={index}
                                                    pas={this.callbackPas}
                                                    defaultValue={this.state.docType[index] ? this.state.docType[index] : "PP"}
                                                    optionsSelect={props.config.booking.hideOptions ? props.config.booking.hideOptions : getDocType()}

                                                />
                                            </Grid>}

                                            <Grid item sm={isRenfeSome ? 12 : 7}>
                                                {this.state.docType[index] === "Nie" ?
                                                    <FormInputNumber
                                                        id={`${'docNumber-'}${index}`}
                                                        name={`${'docNumber-'}${index}`}
                                                        defaultValue={this.state.docNumber[index] ? this.state.docNumber[index].state.defaultValue : ''}
                                                        placeholder="Ingresa un valor"
                                                        ref={element => { this.state.docNumber[index] = element }}
                                                        disabled={this.state.disabled ? this.state.disabled : false}
                                                        initial={(this.state.docNumber[index] !== null) ? false : true}
                                                        error={this.state.errors.docNumber !== undefined ? this.state.errors.docNumber[index] : this.state.errors.text.docNumber}
                                                    />
                                                    :
                                                    props.config.client.country === 'ES' || this.state.pas[index] || this.state.pas[index] === undefined ?

                                                        <StringNumberPass
                                                            id={`${'docNumber-'}${index}`}
                                                            name={`${'docNumber-'}${index}`}
                                                            minLength={7}
                                                            maxLength={9}
                                                            defaultValue={this.state.docNumber[index] ? this.state.docNumber[index].state.defaultValue : ''}
                                                            placeholder="Ingresa un valor"
                                                            ref={element => { this.state.docNumber[index] = element }}
                                                            disabled={this.state.disabled ? this.state.disabled : false}
                                                            initial={(this.state.docNumber[index] !== null) ? false : true}
                                                            error={this.state.errors.docNumber !== undefined ? this.state.errors.docNumber[index] : this.state.errors.text.docNumber}

                                                        />
                                                        :
                                                        this.state.docType !== 'PP' && isRenfeSome === false ?
                                                            <FormInputNumber
                                                                id={`${'docNumber-'}${index}`}
                                                                name={`${'docNumber-'}${index}`}
                                                                defaultValue={this.state.docNumber[index] ? this.state.docNumber[index].state.defaultValue : ''}
                                                                placeholder="Ingresa un valor"
                                                                ref={element => { this.state.docNumber[index] = element }}
                                                                disabled={this.state.disabled ? this.state.disabled : false}
                                                                initial={(this.state.docNumber[index] !== null) ? false : true}
                                                                error={this.state.errors.docNumber !== undefined ? this.state.errors.docNumber[index] : this.state.errors.text.docNumber}
                                                            /> :
                                                            <StringNumber
                                                                id={`${'docNumber-'}${index}`}
                                                                name={`${'docNumber-'}${index}`}
                                                                defaultValue={this.state.docNumber[index] ? this.state.docNumber[index].state.defaultValue : ''}
                                                                placeholder="Ingresa un valor"
                                                                ref={element => { this.state.docNumber[index] = element }}
                                                                disabled={this.state.disabled ? this.state.disabled : false}
                                                                initial={(this.state.docNumber[index] !== null) ? false : true}
                                                                error={this.state.errors.docNumber !== undefined ? this.state.errors.docNumber[index] : this.state.errors.text.docNumber}
                                                            />}
                                            </Grid>
                                        </Grid>
                                    </div>
                                </Grid>
                            }

                            { isRenfeSome &&
                                <Grid item md={6}>
                                    <DatepickerValPass
                                        id={`${'expirationDate-'}${index}`}
                                        name={`${'expirationDate-'}${index}`}
                                        label="Fecha de expiración"
                                        defaultValue={this.state.expirationDate[index] ? this.state.expirationDate[index].state.selectedDate : null}
                                        arrDatePass={this.arrDatePass(props.bookingItems)}
                                        ref={element => { this.state.expirationDate[index] = element }}
                                        placeholder="__/__/____"
                                        disabled={this.state.disabled ? this.state.disabled : false}
                                        error={this.state.errors.expirationDate !== undefined ? this.state.errors.expirationDate[index] : this.state.errors.text.expirationDate}
                                        initial={(this.state.expirationDate[index] !== null) ? false : true}

                                    />
                                </Grid>
                            }

                            {item.type !== 'YOUTH' ?
                                <Grid item md={4}>
                                    <DatePickerRange
                                        id={`${'birthday-'}${index}`}
                                        name={`${'birthday-'}${index}`}
                                        label="Fecha de nacimiento"
                                        defaultValue={this.state.birthday[index] ? this.state.birthday[index].state.selectedDate : null}
                                        ages={item.age}
                                        ref={element => { this.state.birthday[index] = element }}
                                        min={null}
                                        max={null}
                                        departure={props.bookingItems[0].leg ? props.bookingItems[0].leg.departure : props.bookingItems[0].activationPeriod.startDate}
                                        arrival={props.bookingItems[0].leg ? props.bookingItems[0].leg.arrival : props.bookingItems[0].activationPeriod.endDate}
                                        placeholder="__/__/____"
                                        disabled={this.state.disabled ? this.state.disabled : false}
                                        initial={(this.state.birthday[index] !== null && this.state.birthday[index]?.state.selectedDate !== null) ? false : true}
                                        error={this.state.errors.birthday !== undefined ? this.state.errors.birthday[index] : this.state.errors.text.birthday}

                                    />
                                </Grid>
                                :
                                <Grid item md={4}>
                                    <DatePickerDateAge
                                        id={`${'birthday-'}${index}`}
                                        name={`${'birthday-'}${index}`}
                                        label="Fecha de nacimiento"
                                        defaultValue={this.state.birthday[index] ? this.state.birthday[index].state.selectedDate : null}
                                        ages={item.age}
                                        ref={element => { this.state.birthday[index] = element }}
                                        min={null}
                                        max={null}
                                        departure={props.bookingItems[0].leg ? props.bookingItems[bookingItemsLenght].leg.departure : new Date(props.bookingItems[0].validityStartDate).toISOString().slice(0, 19)}
                                        arrival={props.bookingItems[0].leg ? props.bookingItems[bookingItemsLenght].leg.arrival : new Date(props.bookingItems[0].validityStartDate).toISOString().slice(0, 19)}
                                        placeholder="__/__/____"
                                        disabled={this.state.disabled ? this.state.disabled : false}
                                        initial={(this.state.birthday[index] !== null && this.state.birthday[index]?.state.selectedDate !== null) ? false : true}
                                        error={this.state.errors.birthday !== undefined ? this.state.errors.birthday[index] : this.state.errors.text.birthday}
                                    />
                                </Grid>
                            }

                            <Grid item md={4}>
                                <FormInputSelect
                                    id={`country-${index}`}
                                    name={`country-${index}`}
                                    label="Residencia"
                                    defaultValue={this.state.country[index] ? this.state.country[index].state.defaultValue : props.config.client.country}
                                    optionsSelect={getCountry()}
                                    ref={element => { this.state.country[index] = element }}
                                />
                            </Grid>
                            <Grid item md={4}>
                                <FormInputSelect
                                    id={`nationality-${index}`}
                                    name={`nationality-${index}`}
                                    label="Nacionalidad"
                                    defaultValue={this.state.nationality[index] ? this.state.nationality[index].state.defaultValue : props.config.client.country}
                                    optionsSelect={getCountry()}
                                    ref={element => { this.state.nationality[index] = element }}
                                    callbackValue={(e) => this.handlenationality(e, index)}
                                />
                            </Grid>
                            
                           
                            
                            
                        </Grid>
                    </div>
                )}
            </Paper>
        )
    }

    GetPassengersFormPases = (props) => {
        //const renfe = props.bookingItems[0].products[0].supplier === 'RENFE' ? true : false;

        const isRenfeSome = props.bookingItems.some(bookingItem =>
            bookingItem.products.some(product => product.supplier === 'RENFE')
          );

        let bookingItemsLenght = props.bookingItems.length - 1;
		const messageTickets = `Infoas: Viajan gratis sin derecho a asiento y sin ticket según edades: Trenes Reino Unido 0-4 años, Alemania y Suiza de 0-5 años, resto de Trenes 0-3 años inclusive.`
		const messagePasses = `Infoas: Viajan gratis sin derecho a asiento y sin ticket  según edades: Pase Eurail 0-3 años y Pase Suizo de 0-5 años inclusive. `
		const page = sessionStorage.getItem('typeProduct');
        
        return (
            <Paper className="paper form-passengers">
                <Typography variant="h2" className="subtitle">Datos de los pasajeros</Typography>

                {props.bookingItems[0].travelers.map((item, index) =>
                    <div key={index} className="pax">
                        <Typography variant="h4" className="subtitle_pax">Pasajero {index + 1}
                            {item.type === 'ADULT' ? ' (ADULTO' : item.type === 'SENIOR' ? ' (SENIOR' : item.type === 'YOUTH' ? ' (MENOR/JOVEN' : item.type})
                            {item.age < 30 ? item.type === 'YOUTH' && item.age == 1 ? ' (' + item.age + ' año)' : ' (' + item.age + ' años)' : ''}
                            {(item.age <= 5 && page === "tickets")
								&& <span>
								<PopoverSimpleTitleContent
								  name="info_timer"
								  title=''
								  content={messageTickets}
								  icon="info_outline"
								/>
							  </span>}
                            {(item.age <= 5 && page === "passes")
                            && <span>
                            <PopoverSimpleTitleContent
                                name="info_timer"
                                title=''
                                content={messagePasses}
                                icon="info_outline"
                            />
                            </span>}</Typography>

                        <Grid container spacing={1}>
                            <Grid item md={5}>
                                <String
                                    id={`${'firstName-'}${index}`}
                                    name={`${'firstName-'}${index}`}
                                    label="Nombre"
                                    defaultValue={this.state.firstName[index]?.state.defaultValue}
                                    placeholder="Primer Nombre"
                                    ref={element => { this.state.firstName[index] = element }}
                                    disabled={this.state.disabled ? this.state.disabled : false}
                                    error={this.state.errors.firstName !== undefined ? this.state.errors.firstName[index] : this.state.errors.text.firstName}
                                    initial={(this.state.firstName[index] !== null) ? false : true}
                                />
                            </Grid>
                            <Grid item md={5}>
                                <String
                                    id={`${'lastName-'}${index}`}
                                    name={`${'lastName-'}${index}`}
                                    label="Apellido"
                                    defaultValue={this.state.lastName[index]?.state.defaultValue}
                                    ref={element => { this.state.lastName[index] = element }}
                                    placeholder="Primer Apellido"
                                    error={this.state.errors.lastName !== undefined ? this.state.errors.lastName[index] : this.state.errors.text.lastName}
                                    disabled={this.state.disabled ? this.state.disabled : false}
                                    initial={(this.state.lastName[index] !== null) ? false : true}
                                />
                            </Grid>

                            <Grid item md={2}>
                                <FormInputSelect
                                    id={`genre-${index}`}
                                    name={`genre-${index}`}
                                    label="Sexo"
                                    defaultValue={this.state.genre[index] ? this.state.genre[index].state.defaultValue : "M"}
                                    optionsSelect={getGenre()}
                                    ref={element => { this.state.genre[index] = element }}
                                />
                            </Grid>

                           {/*  <Grid item md={6}>
                                <div className="group-inputs">
                                    <div className="label-group">Tipo y número de documento</div>
                                    <Grid container spacing={1}>
                                        <Grid item sm={5}>
                                            <SimpleSelectDocType
                                                ref={element => { this.state.docType[index] = element }}
                                                id={`${'docType-'}${index}${'docType'}`}
                                                name={`${'docType-'}${index}${'docType'}`}
                                                i={index}
                                                pas={this.callbackPas}
                                                defaultValue={this.state.docType[index] ? this.state.docType[index] : "PP"}
                                                optionsSelect={props.config.booking.hideOptions ? props.config.booking.hideOptions : getDocType()}
                                            />
                                        </Grid> 

                                        <Grid item sm={7}>
                                            {this.state.docType[index] === "Nie" ?
                                                <FormInputNumber
                                                    id={`${'docNumber-'}${index}`}
                                                    name={`${'docNumber-'}${index}`}
                                                    defaultValue={this.state.docNumber[index] ? this.state.docNumber[index].state.defaultValue : ''}
                                                    placeholder="Ingresa un valor"
                                                    ref={element => { this.state.docNumber[index] = element }}
                                                    disabled={this.state.disabled ? this.state.disabled : false}
                                                    initial={(this.state.docNumber[index] !== null) ? false : true}
                                                    error={this.state.errors.docNumber !== undefined ? this.state.errors.docNumber[index] : this.state.errors.text.docNumber}
                                                />
                                                : props.config.client.country === 'ES' || this.state.pas[index] || this.state.pas[index] === undefined ?
                                                    <StringNumberPass
                                                        id={`${'docNumber-'}${index}`}
                                                        name={`${'docNumber-'}${index}`}
                                                        minLength={7}
                                                        maxLength={9}
                                                        defaultValue={this.state.docNumber[index] ? this.state.docNumber[index].state.defaultValue : ''}
                                                        placeholder="Ingresa un valor"
                                                        ref={element => { this.state.docNumber[index] = element }}
                                                        disabled={this.state.disabled ? this.state.disabled : false}
                                                        initial={(this.state.docNumber[index] !== null) ? false : true}
                                                        error={this.state.errors.docNumber !== undefined ? this.state.errors.docNumber[index] : this.state.errors.text.docNumber}
                                                    />
                                                    : this.state.docType !== 'PP' && isRenfeSome === false ?
                                                        <FormInputNumber
                                                            id={`${'docNumber-'}${index}`}
                                                            name={`${'docNumber-'}${index}`}
                                                            defaultValue={this.state.docNumber[index] ? this.state.docNumber[index].state.defaultValue : ''}
                                                            placeholder="Ingresa un valor"
                                                            ref={element => { this.state.docNumber[index] = element }}
                                                            disabled={this.state.disabled ? this.state.disabled : false}
                                                            initial={(this.state.docNumber[index] !== null) ? false : true}
                                                            error={this.state.errors.docNumber !== undefined ? this.state.errors.docNumber[index] : this.state.errors.text.docNumber}
                                                        /> 
                                                        : <StringNumber
                                                            id={`${'docNumber-'}${index}`}
                                                            name={`${'docNumber-'}${index}`}
                                                            defaultValue={this.state.docNumber[index] ? this.state.docNumber[index].state.defaultValue : ''}
                                                            placeholder="Ingresa un valor"
                                                            ref={element => { this.state.docNumber[index] = element }}
                                                            disabled={this.state.disabled ? this.state.disabled : false}
                                                            initial={(this.state.docNumber[index] !== null) ? false : true}
                                                            error={this.state.errors.docNumber !== undefined ? this.state.errors.docNumber[index] : this.state.errors.text.docNumber}
                                                        />
                                            }
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid> */}

                            {/* <Grid item md={6}>
                                <DatepickerValPass
                                    id={`${'expirationDate-'}${index}`}
                                    name={`${'expirationDate-'}${index}`}
                                    label="Fecha de expiración"
                                    defaultValue={this.state.expirationDate[index] ? this.state.expirationDate[index].state.selectedDate : null}
                                    arrDatePass={this.arrDatePass(props.bookingItems)}
                                    ref={element => { this.state.expirationDate[index] = element }}
                                    placeholder="__/__/____"
                                    disabled={this.state.disabled ? this.state.disabled : false}
                                    error={this.state.errors.expirationDate !== undefined ? this.state.errors.expirationDate[index] : this.state.errors.text.expirationDate}
                                    initial={(this.state.expirationDate[index] !== null) ? false : true}
                                />
                            </Grid> */}

                            {item.type !== 'YOUTH' ?
                                <Grid item md={4}>
                                    <DatePickerRange
                                        id={`${'birthday-'}${index}`}
                                        name={`${'birthday-'}${index}`}
                                        label="Fecha de nacimiento"
                                        defaultValue={this.state.birthday[index] ? this.state.birthday[index].state.selectedDate : null}
                                        ages={item.age}
                                        ref={element => { this.state.birthday[index] = element }}
                                        min={null}
                                        max={null}
                                        departure={props.bookingItems[0].leg ? props.bookingItems[0].leg.departure : props.bookingItems[0].activationPeriod.startDate}
                                        arrival={props.bookingItems[0].leg ? props.bookingItems[0].leg.arrival : props.bookingItems[0].activationPeriod.endDate}
                                        placeholder="__/__/____"
                                        disabled={this.state.disabled ? this.state.disabled : false}
                                        initial={(this.state.birthday[index] !== null && this.state.birthday[index]?.state.selectedDate !== null) ? false : true}
                                        error={this.state.errors.birthday !== undefined ? this.state.errors.birthday[index] : this.state.errors.text.birthday}

                                    />
                                </Grid>
                                :
                                <Grid item md={4}>
                                    <DatePickerDateAge
                                        id={`${'birthday-'}${index}`}
                                        name={`${'birthday-'}${index}`}
                                        label="Fecha de nacimiento"
                                        defaultValue={this.state.birthday[index] ? this.state.birthday[index].state.selectedDate : null}
                                        ages={item.age}
                                        ref={element => { this.state.birthday[index] = element }}
                                        min={null}
                                        max={null}
                                        departure={props.bookingItems[0].leg ? props.bookingItems[bookingItemsLenght].leg.departure : new Date(props.bookingItems[0].validityStartDate).toISOString().slice(0, 19)}
                                        arrival={props.bookingItems[0].leg ? props.bookingItems[bookingItemsLenght].leg.arrival : new Date(props.bookingItems[0].validityStartDate).toISOString().slice(0, 19)}
                                        placeholder="__/__/____"
                                        disabled={this.state.disabled ? this.state.disabled : false}
                                        initial={(this.state.birthday[index] !== null && this.state.birthday[index]?.state.selectedDate !== null) ? false : true}
                                        error={this.state.errors.birthday !== undefined ? this.state.errors.birthday[index] : this.state.errors.text.birthday}
                                    />
                                </Grid>
                            }

                            <Grid item md={4}>
                                <FormInputSelect
                                    id={`country-${index}`}
                                    name={`country-${index}`}
                                    label="Residencia"
                                    defaultValue={this.state.country[index] ? this.state.country[index].state.defaultValue : props.config.client.country}
                                    optionsSelect={getCountry()}
                                    ref={element => { this.state.country[index] = element }}
                                />
                            </Grid>
                            <Grid item md={4}>
                                <FormInputSelect
                                    id={`nationality-${index}`}
                                    name={`nationality-${index}`}
                                    label="Nacionalidad"
                                    defaultValue={this.state.nationality[index] ? this.state.nationality[index].state.defaultValue : props.config.client.country}
                                    optionsSelect={getCountry()}
                                    ref={element => { this.state.nationality[index] = element }}
                                    callbackValue={(e) => this.handlenationality(e, index)}
                                />
                            </Grid>
                            
                           
                            
                            
                        </Grid>
                    </div>
                )}
            </Paper>
        )
    }

    GetCuilCuitForm = (props) => {

        const cuilcuiTypeHandle = (event) => {
            this.setState({ cuilcuitType: event.target.value });
        };

        return (
            <>
                {this.state.selectedNationality == "AR" &&
                    <Paper className="paper form-passengers">
                        <div className="group-inputs">
                            <div className="label-group">CUIL/CUIT Pasajero Titular (Únicamente mandatorio para ciudadanos argentinos)
                                    <Tooltip placement="top" title="Este dato debe corresponder al pasajero titular de la reserva independientemente de si es o no el pagador de la misma. ">
                                        <Icon style={{ fontSize: 18, verticalAlign: 'middle' }}>info</Icon>
                                    </Tooltip>
                                
                            </div>
                            <Grid container spacing={1}>
                                <Grid item sm={2}>
                                    <FormControl variant="outlined" fullWidth className={`InputForm`}>
                                        <Select
                                            ref={element => { this.cuilcuitType = element }}
                                            labelId="cuilcuitType"
                                            id="cuilcuitType"
                                            value={this.state.cuilcuitType}
                                            defaultValue={this.state.cuilcuitType}
                                            onChange={cuilcuiTypeHandle}
                                        >
                                            <MenuItem value={"CUIL"}>CUIL</MenuItem>
                                            <MenuItem value={"CUIT"}>CUIT</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item md={4}>
                                    <NumberCuit
                                        ref={element => { this.state.cuilcuitNumber = element }}
                                        id={`cuilcuitNumber`}
                                        name={`cuilcuitNumber`}
                                        placeholder="Ingrese un cuit/cuil"
                                        label=""
                                        minLength={null}
                                        maxLength={11}
                                        defaultValue={this.state.cuilcuitNumber ? this.state.cuilcuitNumber.state?.defaultValue : ''}
                                        error={this.state.errors.cuilcuitNumber}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    </Paper >
                }
            </>
        )
    }

    GetContactForm = (props) => {
        return (
            <Paper className="paper form-contact">
                <Typography variant="h1" className="title">{props.config.prebooking.dictionary.title}</Typography>
                <Paper className="block-info info-pasajeros mb-2" variant="outlined">
                    <div className="block-info-container MuiPaper-rounded">
                        <div className="col-icono">
                            <Icon>info</Icon>
                        </div>
                        <div className="col-texto">
                            <Typography>Se debe indicar únicamente el primer nombre y el primer apellido tal cual figuran en el documento de viaje que utilizara el pasajero</Typography>
                        </div>
                    </div>
                </Paper>
                <Typography variant="h2" className="subtitle">Datos de la Agencia</Typography>
                <Grid container spacing={1}>
                    <Grid item md={6}>
                        <String
                            label="Nombre(s)"
                            id={`name`}
                            ref={element => { this.state.contact.name = element }}
                            defaultValue={this.state.contact['name'].state?.defaultValue}
                            name={`name`}
                            placeholder="Ingrese un nombre"
                            disabled={this.state.disabled ? this.state.disabled : false}
                            error={this.state.errors.namecontact}
                            initial={(this.state.contact.name !== '' && this.state.contact.name.state?.defaultValue !== '') ? false : true}
                        />
                    </Grid>
                    <Grid item md={6}>
                        <String
                            label="Apellido(s)"
                            id={`lastname`}
                            ref={element => { this.state.contact.lastname = element }}
                            defaultValue={this.state.contact['lastname'].state?.defaultValue}
                            name={`lastname`}
                            placeholder="Ingrese un apellido"
                            disabled={this.state.disabled ? this.state.disabled : false}
                            error={this.state.errors.lastnamecontact}
                            initial={(this.state.contact.lastname !== '' && this.state.contact.lastname.state?.defaultValue !== '') ? false : true}
                        />
                    </Grid>
                    <Grid item md={6}>
                        <FormInputNumber
                            label="Número de teléfono"
                            id={`phone`}
                            defaultValue={this.state.contact['phone'].state?.defaultValue}
                            ref={element => { this.state.contact.phone = element }}
                            name={`phone`}
                            minLength={9}
                            maxLength={14}
                            placeholder="Ingrese un teléfono"
                            disabled={this.state.disabled ? this.state.disabled : false}
                            error={this.state.errors.phonecontact}
                            initial={(this.state.contact.phone !== '' && this.state.contact.phone.state?.defaultValue !== '') ? false : true}
                        />
                    </Grid>
                    <Grid item md={6}>
                        <Email
                            label="E-mail donde recibirás la confirmación de reserva"
                            id={`email`}
                            defaultValue={this.state.contact['email'].state?.defaultValue}
                            ref={element => { this.state.contact.email = element }}
                            name={`email`}
                            placeholder="Ingrese email"
                            disabled={this.state.disabled ? this.state.disabled : false}
                            error={this.state.errors.emailcontact}
                            initial={(this.state.contact.email !== '' && this.state.contact.email.state?.defaultValue !== '') ? false : true}
                        />
                    </Grid>
                </Grid>
            </Paper>
        )
    }

    render() {
        const tokenClient = this.props.match.params.token
        let config = require(`./../../store/config/${tokenClient}/config.json`);
        const reserve = this.props.location.state.reserve
        const bookingItems = this.props.location.state.reserve.bookingItems
		const ages = bookingItems[0].travelers.map(traveler=> traveler.age).some(age => age <= 5);
		const page = sessionStorage.getItem('typeProduct');
        const conditionsUrl = config.client.conditions
        //const habilitar = true
        const loading = this.state.loading

        console.log('reserve',this.props.location.state.reserve)
        console.log('reserve state',this.state)

        

        /* const timer = {
            "active": true,
            "value": 1,
            "redirect": "https://trenes.gotravelres.com.ar/",
            "infoModal": "Destino - Destino",
            "messages": [
                {
                    "description": "Una vez transcurrido ese tiempo, la reserva caducará y te enviaremos a la pagina de resultados para que elijas uno nuevo.",
                    "title": "Ya estás a un paso de concretar tu reserva! Tenés 5 minuto(s) para completar el formulario."
                }
            ]
        } */
        const timer = this.props.location.state.reserve.timer
        //const expired = false

        //console.log('reserve',this.props.location.state.reserve)



        // const GetPaymentForm = (props) => {
        //     return (
        //         <Paper className="paper form-payment">
        //             <Typography variant="h2" className="subtitle">Formas de pago</Typography>

        //             <PaymentMethods />

        //             <div className="banner sitio-seguro">
        //                 <Grid container spacing={1}>
        //                     <Grid item xs={1}>
        //                         <Icon>verified_user</Icon>
        //                     </Grid>
        //                     <Grid item xs={11}>
        //                         <Typography variant="h4">GoTravelRes Argentina es un sitio seguro</Typography>
        //                         <Typography variant="body2">Utilizamos conexiones seguras para proteger tu información</Typography>
        //                     </Grid>
        //                 </Grid>

        //             </div>
        //         </Paper>
        //     )
        // }

        const pases = bookingItems[0].type === 'pass-offer' ? true : false;

        return (
            <Theme>
                
                <div className={`wrapper checkout checkout-boletos wrapper-${config.client.name}`} styles={config.styles}>
                
                    <Header misReservas={config.misReservas} isLogin={config.credential.isLogin} client={config.client} header={config.header} />
                    <main className={`main_content`}>
                        {this.props.thankyoupage ? (
                            this.props.preload ?
                                <div>cargando</div>
                                : (
                                    <Redirect to={{
                                        pathname: "/" + tokenClient + "/trenes/booking",
                                        state: {
                                            booking: this.props.booking
                                        }
                                    }}
                                        exact
                                    />)
                        ) : (
                            <Container>
                                <Grid container spacing={2}>
                                    <Grid item md={8}>
                                        <div className="form-container">
                                            <form onSubmit={this.handleSubmit} >
                                                <this.GetContactForm config={config} bookingItems={bookingItems} />
                                                {pases ?  <this.GetPassengersFormPases config={config} bookingItems={bookingItems} />
                                                :  <this.GetPassengersFormTickets config={config} bookingItems={bookingItems} />
                                                }
                                                
                                                <this.GetCuilCuitForm />
                                                {/* <GetPaymentForm /> */}

                                                <Grid container spacing={1}>
                                                    <Grid item md={5}>
                                                        <FormGroup className="terminosycondiciones" row>
                                                            <FormControlLabel control={
                                                                <CheckboxForm
                                                                    name={`terminosycondiciones`}
                                                                    //defaultValue={this.state.defaultValue}
                                                                    checked={this.state.checkTermsConditions}
                                                                    onChange={this.checkoutTermsConditions}
                                                                />}
                                                                label={<Typography>Leí y acepto los <Link href={conditionsUrl} target="_blank">Términos y Condiciones</Link></Typography>}
                                                            />
                                                            {!this.state.checkTermsConditions &&
                                                                <Typography className="error" variant="body2">
                                                                    Por favor para continuar acepte los Términos y Condiciones
                                                                </Typography>
                                                            }
                                                        </FormGroup>
                                                    </Grid>
                                                    <Grid item md={4}>
                                                        <Typography className="text-right mt-05" variant="body2">(Todos los campos son obligatorios)</Typography>
                                                    </Grid>
                                                    <Grid item md={3}>
                                                        <div className={`containerButtonProgress`}>
                                                            <div className={`wrapperButtonProgress`}>
                                                                <Button disabled={loading} onClick={this.handleSubmit.bind(this)} className="buttonSubmit mt-05" fullWidth variant="contained" color="primary" >
                                                                    Reservar
                                                                </Button>
                                                                {loading && <CircularProgress size={24} color="inherit" className={`buttonProgress`} />}
                                                            </div>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </form>
                                        </div>
                                    </Grid>
                                    <Grid item md={4}>
                                        <div id="col-resume-wrap" >
                                            <div className="col-resume">
                                                <Timer timer={timer} tokenClient={tokenClient}  />

                                                <PurchaseDetail
                                                    prices={reserve.prices}
                                                    bookingItems={bookingItems}
                                                    purchaseDetail={config.prebooking.purchaseDetail}
                                                    config={config}
                                                    totalText={bookingItems[0].type === 'pass-offer' ? 'Total Pases' : 'Total Boletos'}
                                                />

                                                {bookingItems[0].type === "pass-offer" ?
                                                    <ProductDetailPasses
                                                        bookingItems={bookingItems}
                                                        ages={ages} 
                                                        page={page}
                                                    />
                                                    :
                                                    <ProductDetail
                                                        bookingItems={bookingItems}
                                                        productDetail={config.prebooking.productDetail}
                                                        ages={ages} 
                                                        page={page}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Container>
                        )}
                    </main>
                    <Footer data={config.footer} client={config.client} />
                </div>
            </Theme >
        )
    }
}

const mapStateToProps = reducers => {
    return reducers.checkoutReducer;
};
const mapDispatchToProps = dispatch => {
    return {
        dispatchGetBooking: (query, tokenClient, apiToken) =>
            dispatch(
                getBookingAction(
                    query, tokenClient, apiToken
                ),
            )
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(CheckoutPage);
